/** Keep the editorial destination name prominent without changing canonical SEO titles. */
export function guideDisplayTitle(title: string | null | undefined): string {
  const raw = String(title || "").trim();
  if (!raw) return "Travel guide";
  const compact = raw
    .replace(/\s*[–—-]\s*(?:itinerary(?:\s*&\s*what\s*to\s*do)?|what\s*to\s*do|travel\s*guide)\s*$/i, "")
    .trim();
  return compact || raw;
}
